import { render, staticRenderFns } from "./ListMenuIcon.vue?vue&type=template&id=9e08b746"
import script from "./ListMenuIcon.vue?vue&type=script&lang=ts"
export * from "./ListMenuIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports